import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';

import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';
import {SafeHtmlPipe} from "../../../pipes/safeHtml.pipe";

@Component({
    selector: 'app-modal-info',
    templateUrl: './modal-info.component.html',
    styleUrls: ['./modal-info.component.scss'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatDialogActions, MatButton, MatDialogClose, SafeHtmlPipe]
})
export class ModalInfoComponent implements OnInit {
    data = inject(MAT_DIALOG_DATA);

    content = 'Opération refusée !';
    confirm = 'Ok';
    errors = [];

    constructor() {
        const data = this.data;

        if (
            data != undefined &&
            data.content != undefined &&
            data.content != ''
        )
            {this.content = data.content;}
        if (
            data != undefined &&
            data.confirm != undefined &&
            data.confirm != ''
        )
            {this.confirm = data.confirm;}
        if (data != undefined && data.errors != undefined && data.errors.length)
            {this.errors = data.errors;}
    }

    ngOnInit() {}
}
